import { useDisclosure } from '@mantine/hooks'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'
import { useForm } from 'react-hook-form'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../../../conexoes/api'
import '../../../../css/painelFaturas/fatDispositivos/fatAcoes.css'
import { revelarAlterarplanoFaturas } from '../../../../redux/actions/index'
import { DispositivosService } from '../../../../services/http/dispositivos.service'
import { useGlobal } from '../../../../stores/useGlobal'
import {
  elipseVerde,
  exclamacao,
  fecharJanela,
  lixeiraVermelho
} from '../../../../utils/alternanciaIcones'
import decryptJWT from '../../../../utils/decryptJWT'
import PaginacaoTabela from '../../../../utils/paginacaoTabela'
import ColetaClickstream from '../../../clickstreamAnalise/clickstreamColeta.js'
import { MensagemErro } from '../../../componentesModais/mensagens/mensagemAcao'
import { RenderMensagemAtencao } from '../../../componentesModais/mensagens/mensagemAtencao'
import MensagemInformacao from '../../../componentesModais/mensagens/mensagemInformacao'
import Botao from '../../../Mantine/Botao'
import DatePicker from '../../../Mantine/DatePicker'
import Grid from '../../../Mantine/Grid'
import Group from '../../../Mantine/Group'
import Select from '../../../Mantine/Select'
import Alerta from '../Alerta'

const valorLimite = 50
let contador = 0
let totalPaginas = 0
let totalItens = 0
let itensVar = []

export default function AlterarPlano({
  simcardsSelecionados,
  ordenador,
  handleRespostaSolicitacao
}) {
  const { isLoadingGlobal } = useGlobal()
  const setIsLoadingGlobal = useGlobal((state) => state.setIsLoadingGlobal)

  const { getPlans } = DispositivosService
  const { register, handleSubmit, errors } = useForm()
  const [dsPlano, setDsPlano] = useState()
  const [cdPlano, setCdPlano] = useState()
  const [dsDescricao, setDsDescricao] = useState()
  const [quantidadeLinhasSelecionados, setQuantidadeLinhasSelecionados] =
    useState(0)
  const [linhaRemover, setLinhaRemover] = useState('')
  const [itens, setItens] = useState([])
  const [plans, setPlans] = useState([])
  const [ignorarSimcardsArray, setIgnorarSimcardsArray] = useState([])
  const [controladorValidadorAcao, setControladorValidadorAcao] =
    useState(false)
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [dataAbertura, setDataAbertura] = useState(new Date())

  const [customMensagemAtencao, setCustomMensagemAtencao] = useState('')
  const [carrierName, setCarrierName] = useState('')
  const [carrierCode, setCarrierCode] = useState('')
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemInformacao, setRevelarMensagemInformacao] =
    useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)

  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [openedAlerta, { open: openAlerta, close: closeAlerta }] =
    useDisclosure(false)

  const despacho = useDispatch()
  const modal = useRef()

  const iconeAlerta = (
    <img className="icone-alerta" src={exclamacao()} alt="exclamacao" />
  )

  const cdCliente = decryptJWT('codigoCliente')
  const codigoUsuario = decryptJWT('codigo')

  let filtros = useSelector((state) => state.filtrosState.filtros)
  let buscaArquivo = useSelector(
    (state) => state.buscaArquivoState.buscaArquivo
  )
  let modoSelecaoSimcard = useSelector(
    (state) => state.manejadorState.modoSelecaoSimcard
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let separadorLinha = useSelector(
    (state) => state.manejadorState.separadorLinha
  )

  function limparModal() {
    contador = 0
    totalPaginas = 0
    totalItens = 0
    itensVar = []
  }

  const { isLoading: isLoadingSimcards } = useQuery(
    [
      'fatSimcards',
      paginaAtual,
      conteudoBusca,
      filtros,
      buscaArquivo,
      modoSelecaoSimcard
    ],
    async () => {
      const pagina = paginaAtual - 1
      const urlGet = `/m1/filtrar/fatSimcard?paguinaAtual=${pagina}&buscar=${conteudoBusca}&ordenador=${ordenador}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${JSON.stringify(buscaArquivo)}&separador=${separadorLinha}&cd_pav_usuario=${decryptJWT('codigo')}`
      const response = await api_gateway.get(urlGet)
      return response.data.dados
    },
    {
      enabled: modoSelecaoSimcard === true,
      keepPreviousData: true,
      onSuccess: (consultaSimcards) => {
        inserirData(consultaSimcards)

        setItens([...consultaSimcards])
        setQuantidadeLinhasSelecionados(consultaSimcards.length)
        setIsLoadingGlobal(false)
      },
      onError: () => {
        setIsLoadingGlobal(false)
      }
    }
  )
  const { isLoading: isLoadingInitial } = useQuery(
    ['initialFatSimcards'],
    async () => {
      limparModal()

      await contarItens()
    },
    {
      enabled: !controladorValidadorAcao && !modoSelecaoSimcard,
      onSuccess: () => {
        if (!modoSelecaoSimcard) {
          const auxSelecionados = simcardsSelecionados.map((item) => ({
            ...item,
            DS_CONTA: item.FAT_CONTA || '-',
            DS_OPERADORA: item.OPERADORA,
            DS_CICLO_VIDA: item.FAT_CICLOVIDA || '-',
            DS_PLANO: item.FAT_PLANO ? `${item.FAT_PLANO} MB` : '-'
          }))

          setItens([...auxSelecionados])
          totalPaginas = Math.ceil(simcardsSelecionados.length / 50)
          setQuantidadeLinhasSelecionados(simcardsSelecionados.length)
        }

        setControladorValidadorAcao(true)
        setIsLoadingGlobal(false)
      },
      onError: () => setIsLoadingGlobal(false)
    }
  )

  useEffect(() => {
    ''
    setIsLoadingGlobal(isLoadingSimcards || isLoadingInitial)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingSimcards, isLoadingInitial])

  useQuery(
    ['consultar/fat_plano'],
    async () => {
      const cdOperadoras = [
        ...new Set(simcardsSelecionados.map((item) => item.CD_OPERADORA))
      ]
      return getPlans(cdOperadoras, codigoUsuario)
    },
    {
      onSuccess: (data) => {
        const plans = data?.map((item) => ({
          value: item.cd_fat_plano,
          label: item.ds_plano,
          carrierName: item.ds_apelido,
          carrierCode: item.cd_dsp_operadora
        }))
        setPlans(plans)
        setIsLoadingGlobal(false)
      },
      onError: () => {
        setIsLoadingGlobal(false)
      },
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false
    }
  )

  async function handleCancelar() {
    limparModal()
    ColetaClickstream(1153) // alterarPlanoCancelar
    setIsLoadingGlobal(false)
    despacho(revelarAlterarplanoFaturas(false))
  }

  const colunas = [
    {
      dataField: 'CD_SIMCARD',
      text: 'Código',
      headerClasses: 'nao-selecionavel',
      hidden: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'DS_CONTA',
      text: 'Conta',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'CALLERID',
      text: 'Linha',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'DS_OPERADORA',
      text: 'Operadora',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'ICCID',
      text: 'ICCID',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'DS_CICLO_VIDA',
      text: 'Ciclo de vida',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'DS_PLANO',
      text: 'Plano',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'acoes',
      text: '',
      sort: false,
      headerClasses: 'tabela-coluna-ultima-header nao-selecionavel',
      formatter: () => {
        return (
          <Button
            variant="danger"
            className="botoes-tabela-acoes"
            size="sm"
            onClick={() => handleMensagemAtencao(false)}
          >
            <img
              className="icone-botao-acao-tabela"
              src={lixeiraVermelho()}
              alt="remover-linha"
            />
          </Button>
        )
      }
    }
  ]

  const opcoesPaginacao = {
    page: paginaAtual,
    showTotal: true,
    sizePerPage: valorLimite,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Proxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (page) => {
      setPaginaAtual(page)
    }
  }

  async function contarItens() {
    let arrayItens = []

    const urlGet = `/m1/filtrar/fatSimcard?paguinaAtual=${contador}&carregarLimit=${valorLimite}&buscar=${conteudoBusca}&ordenador=${ordenador}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${JSON.stringify(buscaArquivo)}&separador=${separadorLinha}&contar=true&cd_pav_usuario=${decryptJWT('codigo')}`
    const apiData = await api_gateway
      .get(urlGet)
      .then(function (resposta) {
        return resposta
      })
      .catch(function (erro) {
        throw erro
      })

    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    setQuantidadeLinhasSelecionados(apiData.data.dados[0].CONTADOR)

    for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
      arrayItens.push(i)
    }
    itensVar = arrayItens
  }

  const eventosLinhas = {
    onClick: (e, row) => {
      setLinhaRemover(row.CD_SIMCARD)
    }
  }

  async function handleRemoverLinha(CD_SIMCARD) {
    ColetaClickstream(1154) // alterarPlanoRemoverLinha
    setRevelarMensagemAtencao(false)
    itens.forEach(function (e, index) {
      if (CD_SIMCARD == e.CD_SIMCARD) {
        itens.splice(index, 1)
        setIgnorarSimcardsArray((prev) => [...prev, CD_SIMCARD])
      }
    })
    await contarItens()
    handleLinhasSelecionadas()
  }

  function handleLinhasSelecionadas() {
    setQuantidadeLinhasSelecionados(itens.length)
    if (itens.length === 0) {
      handleCancelar()
    }
  }

  function inserirData(data) {
    if (itensVar.length == totalItens) {
      for (let i = 0; i < totalItens; i++) {
        if (contador === i) {
          let k = i
          for (let j = 0; j < data.length; j++) {
            itensVar[k] = data[j]
            k++
          }
        }
        if (i == totalItens - 1) {
          setItens(JSON.parse(JSON.stringify(itensVar)))
        }
      }
    }
  }

  async function handleSalvar() {
    const carrier = itens[0]?.CD_OPERADORA
    const carrierCheck = itens?.every((item) => item.CD_OPERADORA === carrier)

    const carrierData = plans.find((item) => item.value === dsPlano)
    if (!carrierCheck) {
      const { carrierName, carrierCode } = carrierData
      setCarrierName(carrierName)
      setCarrierCode(carrierCode)
      openAlerta()
      return
    }

    ColetaClickstream(1155) // alterarPlanoConfirmar
    setIsLoadingGlobal(true)
    await api_gateway
      .post('/api/v2/solicitacao', {
        cd_pav_cliente: cdCliente,
        modoSelecao: modoSelecaoSimcard,
        ds_solicitacao: 'Alteração de Plano',
        cd_fat_solicitacao_tipo: 12,
        cd_sol_solicita_tipo: 1,
        cd_fat_solicitacao_status: 1,
        dt_inicio: moment(dataAbertura).format('YYYY-MM-DD HH:mm:ss'),
        dt_prazo_conclusao: '0000-00-00 00:00:00',
        ds_motivo: dsDescricao,
        ds_protocolo_operadora: '',
        cd_fat_plano: cdPlano,
        simcards: itens.map((item) => {
          return item.CD_SIMCARD
        }),
        cd_pav_usuario_created: decryptJWT('codigo'),
        filtros: filtros,
        buscaArquivo: buscaArquivo,
        buscar: conteudoBusca,
        separador: separadorLinha,
        ignorarSimcardsArray: ignorarSimcardsArray
      })
      .then(function (response) {
        if (response.data.info === 'informacao') {
          handleMensagemInformacao(false)
        } else if (response.data.info === 'oparadora_duplicada') {
          setMensagemErro(
            'As linhas selecionadas pertencem à operadoras diferentes.'
          )
          handleMensagemErro(false)
        }

        handleRespostaSolicitacao({ response })
      })
      .catch(function (error) {
        const { atencao, erro } = handleRespostaSolicitacao({ error })
        if (atencao) {
          setCustomMensagemAtencao(atencao)
          setRevelarMensagemAtencao(true)
        } else if (erro) {
          setMensagemErro('Erro na solicitação')
          handleMensagemErro(false)
        }
      })
      .finally(() => {
        setIsLoadingGlobal(false)
      })
  }

  function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      setCustomMensagemAtencao('')
    }
    if (confirmacao === true) {
      setQuantidadeLinhasSelecionados(quantidadeLinhasSelecionados - 1)
      handleRemoverLinha(linhaRemover)
    }
  }

  function handleMensagemInformacao(confirmacao) {
    if (revelarMensagemInformacao === false) {
      setRevelarMensagemInformacao(true)
    } else {
      setRevelarMensagemInformacao(false)
      handleCancelar()
    }
    if (confirmacao) {
      handleCancelar()
    }
  }

  function handleMensagemErro(confirmacao) {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
    if (confirmacao === true) {
      //ALGUMA FUNÇÃO
    }
  }

  const handleFilterByCarrier = () => {
    const updatedItens = itens.filter(
      (item) => item.CD_OPERADORA === carrierCode
    )
    setItens(updatedItens)
    setPlans(plans?.filter((item) => item.carrierCode === carrierCode))
    setQuantidadeLinhasSelecionados(updatedItens.length)
  }

  return (
    <Form ref={modal} onSubmit={handleSubmit(() => handleSalvar())}>
      <div className="modal-acao-alterar-ciclo-vida fundo-cor-6">
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Alterar plano</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Grid colSize={[7, 5]}>
              <Select
                label="Novo plano"
                searchable
                placeholder="Selecione"
                options={plans}
                value={dsPlano}
                onChange={(e) => {
                  setDsPlano(e)
                  setCdPlano(e)
                }}
              />
              <DatePicker
                label="Abertura da solicitação"
                prefixo="De:"
                value={dataAbertura}
                onChange={(e) => setDataAbertura(e)}
              />
            </Grid>
          </Col>
        </Form.Row>
        <Form.Row style={{ marginTop: '10px' }}>
          <Col>
            <Form.Group>
              <Form.Label>
                <div className="fonte-cor-1 label-campo-descricao">
                  Descrição
                </div>
              </Form.Label>
              <Form.Control
                name="descricao"
                className="campo-texto-cor-3 campo-texto-area"
                as="textarea"
                rows="3"
                maxLength="255"
                placeholder="Descreva aqui o motivo"
                ref={register({ required: true, min: 3, max: 255 })}
                onChange={(e) => setDsDescricao(e.target.value)}
              />
              {errors.descricao && (
                <p className="fonte-cor-3 label-alerta">
                  {iconeAlerta} Campo obrigatório.
                </p>
              )}
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="container-tabela-modal-faturas">
              <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
                {({ paginationProps, paginationTableProps }) => (
                  <>
                    <BootstrapTable
                      classes="tabela-transparente-modais"
                      condensed
                      keyField="CD_SIMCARD"
                      data={itens}
                      columns={colunas}
                      rowEvents={eventosLinhas}
                      noDataIndication={
                        !isLoadingGlobal && 'Nenhum item encontrado'
                      }
                      bootstrap4
                      {...paginationTableProps}
                    />
                    {modoSelecaoSimcard && (
                      <div className="paguinacao-tabela-modal">
                        <PaginacaoTabela
                          extrato
                          setPaginaAtual={setPaginaAtual}
                          totalPaginas={totalPaginas}
                          totalItens={totalItens}
                          valorLimite={valorLimite}
                          paginaAtual={paginaAtual}
                          page={paginationProps.page}
                          onPageChange={paginationProps.onPageChange}
                        />
                      </div>
                    )}
                  </>
                )}
              </PaginationProvider>
            </div>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <span className="fonte-cor-1 label-normal contador-linhas-acao-altera-ciclo-vida">
              {quantidadeLinhasSelecionados} linhas selecionadas
            </span>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Group position="right" mt="xl">
              <Botao
                label="Cancelar"
                variant="outline"
                onClick={handleCancelar}
              />

              <Botao
                disabled={
                  !dsPlano || !dataAbertura || dsDescricao == '' || !dsDescricao
                }
                type="submit"
                label="Confirmar"
                onClick={handleSalvar}
              />
            </Group>
          </Col>
        </Form.Row>
      </div>

      {revelarMensagemInformacao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemInformacao
              handleMensagemInformacao={handleMensagemInformacao}
              mensagemTitulo="A solicitação está sendo gerada!"
              mensagemParagrafo1="Esse processo levará alguns minutos, assim que estiver pronto você receberá uma mensagem de conclusão pela plataforma."
              mensagemBotao="Confirmar"
            />
          </div>
        </div>
      )}

      {revelarMensagemAtencao && customMensagemAtencao && (
        <RenderMensagemAtencao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo={customMensagemAtencao}
          mensagemBotao="Retornar"
        />
      )}

      {revelarMensagemAtencao && !customMensagemAtencao && (
        <RenderMensagemAtencao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo="Remover linha?"
          mensagemBotao="Remover"
        />
      )}

      {revelarMensagemErro && (
        <MensagemErro
          handleMensagem={handleMensagemErro}
          mensagemTitulo="Erro"
          mensagemParagrafo1={mensagemErro}
          mensagemBotao="Retornar"
        />
      )}

      {openedAlerta && (
        <Alerta
          opened={openedAlerta}
          onClose={() => closeAlerta()}
          onConfirm={() => {
            handleFilterByCarrier()
            closeAlerta()
          }}
          carrierName={carrierName}
        />
      )}
    </Form>
  )
}
